import { Auth } from 'aws-amplify';

const state = {
    web_user: {
        authenticated: false,
        access_token: null,
        refresh_token: null,
    },
}

const getters = {
    signedIn: (state) => {
        return state.web_user.authenticated;
    },
    getWebUserToken: state => state.web_user.access_token,
    webUserAuthed: state => {return state.web_user.authenticated;}, // Used for router
}

const mutations = {
    findUser: async (state) => {
        try {
            const user = await Auth.currentAuthenticatedUser();
            state.web_user.authenticated = true;
            state.web_user.access_token  = user.signInUserSession.accessToken.jwtToken;
            state.web_user.refresh_token = user.signInUserSession.refreshToken.token;
        }
        catch (err) {
            state.web_user.authenticated = false;
            state.web_user.access_token  = null;
            state.web_user.refresh_token = null;
        }
    },
}

const actions = {
    findUser: (context) => {
        context.commit("findUser")
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
